export default "__VITE_ASSET__BC9yYq0Y__"